import { defaultZodCatch } from '@/lib/converters/defaultZodCatch'
import { favoriteItemConverter } from '@/lib/converters/favorite/favoriteListItem/favoriteItemConverter'
import { paginationConverter } from '@/lib/converters/pagination/paginationConverter'
import { zFavoriteMultipleListResponse } from '@/schemas/favoriteMultipleListResponseSchema'

import type { FavoriteListsListDto } from '@/gen/bff'
import type { FavoriteMultipleListResponseSchema } from '@/schemas/favoriteMultipleListResponseSchema'

export const getMultipleFavoriteListConverter = (data: FavoriteListsListDto): FavoriteMultipleListResponseSchema => {
  const response = {
    results: data.results?.map(favoriteItemConverter) ?? undefined,
    pagination: data.pagination ? paginationConverter(data.pagination) : undefined,
  }

  return zFavoriteMultipleListResponse.catch(defaultZodCatch).parse(response)
}
